import { apiInstance, gql } from "@/services/httpAdapter";

export async function updateGeneralMotorsCSISingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateGeneralMotorsCSISingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMProgramInput!) {
			updateGeneralMotorsCSISingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateGeneralMotorsCSISingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateGeneralMotorsEBESingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateGeneralMotorsEBESingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMProgramInput!) {
			updateGeneralMotorsEBESingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateGeneralMotorsEBESingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateGeneralMotorsSFESingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateGeneralMotorsSFESingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMProgramInput!) {
			updateGeneralMotorsSFESingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateGeneralMotorsSFESingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateGeneralMotorsPASESingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateGeneralMotorsPASESingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMProgramInput!) {
			updateGeneralMotorsPASESingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateGeneralMotorsPASESingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateGeneralMotorsPinnacleSingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateGeneralMotorsPinnacleSingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMProgramInput!) {
			updateGeneralMotorsPinnacleSingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateGeneralMotorsPinnacleSingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateMitsubishiCSISingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateMitsubishiCSISingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMInputMetricsInput!) {
			updateMitsubishiCSISingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateMitsubishiCSISingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateMitsubishiSSISingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateMitsubishiSSISingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMInputMetricsInput!) {
			updateMitsubishiSSISingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateMitsubishiSSISingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateVolvoCSISingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateVolvoCSISingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMInputMetricsInput!) {
			updateVolvoCSISingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateVolvoCSISingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateStellantisCSISingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateStellantisCSISingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMInputMetricsInput!) {
			updateStellantisCSISingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				dealerCodeFS
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateStellantisCSISingleMetric;
	} catch (err) {
		throw new Error(err);
	}
}

export async function updateStellantisSSISingleMetric(locationId, commissionCycleId, input) {
	const query = gql`
		mutation updateStellantisSSISingleMetric($locationId: String!, $commissionCycleId: String!, $input: OEMInputMetricsInput!) {
			updateStellantisSSISingleMetric(locationId: $locationId, commissionCycleId: $commissionCycleId, input: $input) {
				_id
				commissionCycleId
				locationId
				oemReference
				oemVersion
				dealerCodeFS
				content
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateStellantisSSISingleMetric;
	} catch (err) {
		console.error(err);
		return null;
	}
}
